/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 20, height = 20 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 25 24" fill="none">
    <path d="M8.5 1.58643V5.58643M16.5 1.58643V5.58643M21.5 12.5864V5.58643C21.5 5.05599 21.2893 4.54728 20.9142 4.17221C20.5391 3.79714 20.0304 3.58643 19.5 3.58643H5.5C4.96957 3.58643 4.46086 3.79714 4.08579 4.17221C3.71071 4.54728 3.5 5.05599 3.5 5.58643V19.5864C3.5 20.1169 3.71071 20.6256 4.08579 21.0006C4.46086 21.3757 4.96957 21.5864 5.5 21.5864H13.5M3.5 9.58643H21.5M16.5 18.5864H22.5M19.5 15.5864V21.5864" stroke="#262626" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>

);

export default SvgComponent;
